module.exports = __webpack_public_path__ + "img/H2.f726e2ad.png";